import { ForwardedRef, forwardRef, memo } from 'react';
import { WebView } from 'react-native-webview';
import { WebViewProps } from './WebView.types';

function CustomWebView(props: WebViewProps, ref: ForwardedRef<WebView>) {
  return <WebView ref={ref} {...props} />;
}

export default memo(forwardRef(CustomWebView));
